import { pathNames } from "@/lib/constants/pathNames.constants";

export const chips = [
	{
		icon: "lightbulb-flash-line.svg",
		title: "pages.home.hero-banner.chips.solutions",
		url: pathNames.solutions,
	},
	{
		icon: "cpu-line-m.svg",
		title: "pages.home.hero-banner.chips.device-drivers",
		url: pathNames.drivers,
	},
	{
		icon: "code-s-slash-line-m.svg",
		title: "pages.home.hero-banner.chips.open-source",
		url: pathNames.openSource,
	},
	{
		icon: "calendar-event-line-m.svg",
		title: "pages.home.hero-banner.chips.events",
		url: pathNames.events,
	},
];
